import { render, staticRenderFns } from "./BaseModalBiOptions.vue?vue&type=template&id=3ea996a6&"
import script from "./BaseModalBiOptions.vue?vue&type=script&lang=js&"
export * from "./BaseModalBiOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports